import React, {Component} from 'react';
import axios from 'axios';

class ContactForm extends Component {

    state = {
        contactInfo: {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            company: "",
            message: "",
            honeyPot: false
        }
    }

    handleChange = (e) => {
        const contactInfo = this.state.contactInfo;
        contactInfo[e.target.name] = e.target.value;
        this.setState({contactInfo});
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let contactInfo = this.state.contactInfo;
        axios.post('/contact', contactInfo)
        .then((res)=>{
            alert(res.data);
            if (res.data === 'Thank you for contacting us. We will be in touch soon.'){
                contactInfo = {
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    company: "",
                    message: "",
                    honeyPot: false
                }
                this.setState({contactInfo});
                this.props.toggleModal();
            }
        })
        .catch((err)=>{
            console.log(err);
            alert("Whoops! Something went wrong.\nContact us at thegoat@candidgoat.com");
        })
    }

    render (props) {
    return (
    <div className="ContactForm turnBlack centerText">
        <h1 className="titleFont boldest turnBlack">Contact Us</h1>
        <div id="contactFormWrapper" className="container">
            <form onSubmit={this.handleSubmit} className="turnBlack">
            <div className="flexRow">
                <div className="firstName turnBlack width-6 smallFont flexColumn alignStart">
                    <label htmlFor="firstname" className="required" >First Name</label>
                    <input value={this.state.contactInfo.firstName} onChange={this.handleChange} name="firstName" type="text" required placeholder="Required" className="tinyFont"/>
                </div>
                <div className="lastName turnBlack width-6 smallFont flexColumn alignStart">
                    <label htmlFor="lastname" className="required" >Last Name</label>
                    <input value={this.state.contactInfo.lastName} onChange={this.handleChange} name="lastName" type="text" required placeholder="Required" className="tinyFont"/>
                </div>
            </div>
            <div className="flexRow">
                <div className="email turnBlack width-6 smallFont flexColumn alignStart">
                    <label htmlFor="email" className="required" >Email</label>
                    <input value={this.state.contactInfo.email} onChange={this.handleChange} name="email" type="email" required placeholder="Required" className="tinyFont"/>
                </div>
                <div className="phone turnBlack width-6 smallFont flexColumn alignStart">
                    <label htmlFor="phone" >Phone</label>
                    <input value={this.state.contactInfo.phone} onChange={this.handleChange} name="phone" type="number" className="tinyFont" />
                </div>
            </div>
            <div className="flexRow">
                <div className="company turnBlack smallFont flexColumn alignStart width-12">
                    <label htmlFor="company" >Company</label>
                    <input value={this.state.contactInfo.company} onChange={this.handleChange} name="company" type="text" className="tinyFont"/>
                </div>
            </div>
            <div className="flexRow">
                <div className="message turnBlack smallFont flexColumn alignStart width-12">
                    <label htmlFor="message" className="required" >Message</label>
                    <textarea value={this.state.contactInfo.message} onChange={this.handleChange} name="message" required placeholder="Required" className="tinyFont"/>
                </div>
            </div>
            <div className="flexRow">
                <div className="submit turnBlack smallFont flexColumn width-12">
                    <input id="honeyPot" type="checkbox" name="contact_me_by_fax_only" value="1" tabIndex="-1" autoComplete="off" className="honeyPot"/>
                    <input type="submit" className="button bodyFont boldest noPadding" />
                </div>
            </div>
            </form>
        </div>
    </div>
    )}
}


export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/ContactForm.js